/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthSendEmailVerification200Response
 */
export interface AuthSendEmailVerification200Response {
    /**
     * 
     * @type {boolean}
     * @memberof AuthSendEmailVerification200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthSendEmailVerification200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the AuthSendEmailVerification200Response interface.
 */
export function instanceOfAuthSendEmailVerification200Response(value: object): value is AuthSendEmailVerification200Response {
    return true;
}

export function AuthSendEmailVerification200ResponseFromJSON(json: any): AuthSendEmailVerification200Response {
    return AuthSendEmailVerification200ResponseFromJSONTyped(json, false);
}

export function AuthSendEmailVerification200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthSendEmailVerification200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function AuthSendEmailVerification200ResponseToJSON(json: any): AuthSendEmailVerification200Response {
    return AuthSendEmailVerification200ResponseToJSONTyped(json, false);
}

export function AuthSendEmailVerification200ResponseToJSONTyped(value?: AuthSendEmailVerification200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

